var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoArchway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68.354,
    height: 13.462,
    fill: "none",
    viewBox: "0 0 68.354 13.462",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.9157 0c-3.8194 0-6.9157 3.0145-6.9157 6.7331l6.7536e-6 6.6262c0-3.689 3.0963-6.6796 6.9157-6.6796 3.8171 0 6.912 2.987 6.9157 6.673v-6.6196c0-3.7186-3.0963-6.7331-6.9157-6.7331z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.579 11.164-3.1605-8.9114h-2.9683l-3.1605 8.9114h1.6343l0.8773-2.5562h4.2661l0.8773 2.5562zm-4.6386-8.7238 1.6824 4.8778h-3.3769z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.578 4.844h-1.4901v6.32h1.5022v-3.5411c0-1.1022 0.5648-1.4774 1.7304-1.4774h0.4086v-1.4422c-1.2498 0-1.8987 0.72697-2.1511 1.6767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.312 8.9831c-0.3245 1.5008-1.5623 2.3216-3.1125 2.3216-1.9588 0-3.2446-1.3367-3.2446-3.3066s1.2978-3.2948 3.2446-3.2948c1.6584 0 2.776 0.93803 3.0524 2.3451h-1.5262c-0.1682-0.72698-0.6609-1.3132-1.5262-1.3132-1.0935 0-1.7184 0.87941-1.7184 2.263 0 1.4071 0.6369 2.2748 1.7184 2.2748 0.8532 0 1.358-0.46905 1.5983-1.2898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.694 4.7033c-1.1176 0-1.7545 0.65662-2.0549 1.4305v-3.8811h-1.4902v8.9114h1.5022v-3.6701c0-1.2077 0.5288-1.7471 1.37-1.7471 0.8532 0 1.3699 0.52765 1.3699 1.7236v3.6935h1.5022v-3.9749c0-1.4071-0.7091-2.4858-2.1992-2.4858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.095 4.844 1.0815 6.1676 1.3459-6.1676h1.406l-1.3939 6.32h-2.7159l-1.0575-6.1793-1.0575 6.1793h-2.7159l-1.394-6.32h1.406l1.3459 6.1676 1.0816-6.1676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.358 4.7033c-1.5862 0-2.6918 0.7856-2.848 2.0285h1.5141c0.0841-0.52764 0.5288-0.99666 1.3339-0.99666 0.9013 0 1.3339 0.598 1.3339 1.3367v0.10553l-1.7184 0.17588c-1.2258 0.11726-2.6799 0.43385-2.6799 1.8995 0 1.196 0.9855 2.052 2.2112 2.052 1.2378 0 1.7906-0.5628 2.1991-1.3953v1.2546h1.4902v-4.0336c0-1.2898-0.8412-2.4272-2.8361-2.4272zm-0.2764 5.6751c-0.6849 0-1.2618-0.4104-1.2618-1.1256 0-0.82078 0.8893-0.93804 1.7065-1.0318l1.1656-0.11726v0.37522c0 1.0553-0.5407 1.8995-1.6103 1.8995z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.079 4.844 1.9708 5.4289 1.7305-5.4289h1.5743l-2.776 8.6182h-1.5502l0.9493-2.9783h-1.3339l-2.079-5.6399z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArchway);
export default __webpack_public_path__ + "static/media/logo-archway.1f7098a6515c13ff6477b945e35c5fb8.svg";
export { ForwardRef as ReactComponent };